import { Button, Col, DatePicker, Form, Input, Popover, Row } from "antd"
import { RangePickerProps } from "antd/es/date-picker";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import SearchInput from "../../../../components/Commons/Input/SearchInput";


const { Search } = Input;

export default function FilterPending(props: any) {
    const {
        formSearch,
        setCurrentPage,
        setSearch,
        formFilter,
        setStartDate,
        setEndDate,
        setStatus,
        startDate,
        endDate,
        status,
        setFilters
    } = props

    const [openFilters, setOpenFilters] = useState<boolean>(false);

    const onFilter = () => {
        setCurrentPage(1);
        let start_date = formFilter.getFieldValue('filter_start_date');
        let end_date = formFilter.getFieldValue('filter_end_date');

        setStartDate(start_date ? start_date.format('YYYY-MM-DD') : '');
        setEndDate(end_date ? end_date.format('YYYY-MM-DD') : '');
        setStatus(formFilter.getFieldValue('filter_status'));
    };

    const onSearch = (search_value: any) => {
        setCurrentPage(1);
        setSearch(search_value);
    };

    const disabledStartDate: RangePickerProps['disabledDate'] = (current) => {
        let endDate = formFilter.getFieldValue('filter_end_date');

        if (endDate) {
            return current >= endDate;
        }

        return false;
    };

    const disabledEndDate: RangePickerProps['disabledDate'] = (current) => {
        let startDate = formFilter.getFieldValue('filter_start_date');

        if (startDate) {
            return current <= startDate;
        }

        return false;
    };

    const onClearFilters = () => {
        setCurrentPage(1);
        setStartDate('');
        setEndDate('');
        setStatus('');
    };

    const handleOpenFiltersChange = (open: boolean) => {
        setOpenFilters(open);
    };

    useEffect(() => {
        setFilters((
            <Form
                form={formFilter}
                name="filter_bookings"
                layout="vertical"
                className="form_filter_horizontal"
                autoComplete="off"
                style={isMobile ? {} : { width: 300 }}>
                <Row>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                        <Form.Item label="Data início" name="filter_start_date" className="item_filter">
                            <DatePicker size="large" placeholder="dd/mm/aaaa" showToday={false}
                                format={'DD/MM/YYYY'} disabledDate={disabledStartDate} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
    
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                        <Form.Item label="Data fim" name="filter_end_date" className="item_filter">
                            <DatePicker size="large" placeholder="dd/mm/aaaa" showToday={false}
                                format={'DD/MM/YYYY'} disabledDate={disabledEndDate} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
    
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }}>
                        <Button onClick={onFilter} size="large">Filtrar</Button>
                        {startDate}
    
                        {(startDate || endDate || status)
                            && <Button type="link" onClick={onClearFilters} size="large">Limpar</Button>
                        }
                    </Col>
                </Row>
            </Form>
        ));
    }, []);

    return (
        <>
            <div className="search_bar">
                <SearchInput
                    form={formSearch}
                    name="search_bookings"
                    buttonText="Pesquisar"
                    placeholder="Pesquisa por nome do cliente, n° reserva ou referência"
                    onSearch={onSearch}
                />
            </div>
        </>
    )
}   